import React, { useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    Typography,
    Grid,
    Button,
    IconButton,
} from '@material-ui/core';
import theme from '../../../theme';
import jMoment from 'moment-jalaali';
import Icon from '@mdi/react';
import {
    mdiChevronDown, mdiClose, mdiPlusCircleOutline, mdiRepeat,
} from '@mdi/js';
import SimpleTable from '../../../components/ui/tables/simpletable';
import { baseHead, approvedHead } from '../tableheadinfo'
import Dropdown from '../../../components/ui/button/dropdown';
import ExcelExport from '../../../components/export/excelexport';
import { transformLogo, translate } from '../../../utils/helpers';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../../utils/handleError';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            '& .MuiFormControl-marginNormal': {
                marginTop: 0,
            },
        },
        '.margin-date-0': {
            '&.MuiFormControl-marginNormal': {
                marginTop: 0,
            },
        },
        paper: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: '100%',
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            border: '1px solid #D8D8D8',
            boxShadow: '0px 1px 12px 4px rgba(0, 0, 0, 0.04)',
            borderRadius: '10px',
            backgroundColor: "#fff",
        },
        headerBox: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '28px',
            position: 'fixed',
            top: '0',
            right: '0',
            width: '100%',
            padding: '20px 68px 20px 90px',
            backgroundColor: "#fff",
            boxShadow: "0px 1px 12px 4px rgba(0, 0, 0, 0.04)",
            zIndex: 12,
        },
        item: {
            display: 'flex',
            alignSelf: 'center',
            alignItems: 'center',
            fontWeight: 500,
            width: '100%',
        },
    }),
);

const token = localStorage.getItem('token') || '';


const Manual3PL = (props: any) => {
    const classes = useStyles();
    const tplMenu = props.tpls.filter(item => props.selected.includes(item.id)).map((item: any) => {
        return {
            name: translate(item.code, "TPL"),
            value: item.id
        }
    })
    const notAssignedAction = {
        head: () => (<Icon path={mdiChevronDown} size={1.5} />),
        body: (row: any) => (
            <div style={{ display: "flex", alignItems: "center" }}>
                {row.suggestedTplId ? <img src={transformLogo(row.suggestedTplId)} alt="3pl image" width="30px" height="30px" onClick={() => handleChange3PL(row, null)} />
                    : <Dropdown label={() => (
                        <>
                            <Icon path={mdiPlusCircleOutline} size={1} />
                            کوریر
                        </>
                    )}
                        menues={tplMenu}
                        handleClick={(value: any) => handleChange3PL(row, value)}
                    />}
                <IconButton onClick={() => removeOrder(row)}>
                    <Icon path={mdiClose} size={1} color={"#FF2400"} />
                </IconButton>
            </div>
        ),
    }

    const handleChange3PL = (row: any, value: any) => {
        const newData = props.data.APPROVED.map(item => {
            if (item.id == row.id) {
                return {
                    ...item,
                    suggestedTplId: value
                }
            } else {
                return item
            }
        })
        props.setData({ NOT_APPROVED: props.data.NOT_APPROVED, APPROVED: newData })
    }

    const removeOrder = (row: any) => {
        const newData = props.data.APPROVED.filter(item => item.id !== row.id);
        props.setData({ NOT_APPROVED: props.data.NOT_APPROVED, APPROVED: newData })
    }

    const notApprovedExcel = (data: any) => {
        return data.map((item: any) => {
            return {
                id: item.id,
                customerAddress: item.customerAddress,
                centerName: item.centerName,
                partnerName: item.partnerName,
                deliveryDate:
                    item.deliveryDate &&
                    jMoment(item.deliveryDate, 'YYYY/M/D')
                        .locale('fa')
                        .format('jYY/jMM/jDD'),
                deliveryTime: `${jMoment(item.deliveryStartTime, 'hh:mm:ss').locale('fa').format('HH:mm')}
                -
                ${jMoment(item.deliveryEndTime, 'hh:mm:ss').locale('fa').format('HH:mm')}`,
                // weight: item?.orderPackages[0].totalWeight,
                // size: `${item?.orderPackages[0].length}×${item?.orderPackages[0].width}×${item?.orderPackages[0].height}`,
                errorOfSuggestion: item.errorOfSuggestion
            };
        });
    };

    const returnToUpload = () => {
        props.setState("UPLOAD")
    }

    const submit = async () => {
        const idTocode = {
            18: 'TAROFF_V2',
            2: 'LINK_EXPRESS',
            3: 'ALOPEYK',
            4: 'CHAPAR',
            5: 'PETROEX',
            6: 'PISHRO_POST',
            7: 'DTSXP',
            8: 'SPEED',
            9: 'TAPIN_POST',
            10: 'TAPIN_KETAB',
        }
        const body = props.data.APPROVED.map(item => {
            return {
                orderId: item.id,
                tplCode: idTocode[item.suggestedTplId]
            }
        })
        try {
            const response = await ordersRepository.createBatchTpl({ payload: { body } })
            props.setData({ ...props.data, REPORT: response.data })
            props.setState("REPORT")
        } catch (err) {
            handleError(err)
        }

    }

    return (
        <>
            <div className={classes.headerBox}>
                <Typography variant="h6" component="h2">
                    ثبت دستی 3PL
                </Typography>
                <div>
                    <Button variant='contained' color="primary" style={{ marginLeft: "10px" }} onClick={submit}>
                        تایید
                    </Button>
                    <Button variant='outlined' color="primary" onClick={returnToUpload}>
                        بازگشت
                    </Button>
                </div>
            </div>
            {/* not-approved Table */}
            {props.data.NOT_APPROVED && <Grid container item xs={12} alignItems="flex-end" style={{ marginTop: "50px" }}>
                <Grid container justifyContent='space-between'>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Icon path={mdiClose} size={1} color={'#fff'} style={{ backgroundColor: "#FF2400", borderRadius: "50px", marginLeft: "15px" }} />
                            <h4 className='text-error'>تایید نشده (2 سفارش)</h4>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <ExcelExport data={notApprovedExcel(props.data.NOT_APPROVED)} label="دریافت" />
                    </Grid>
                </Grid>
                <div className={classes.item}>
                    <div className={classes.paper}>
                        <SimpleTable head={baseHead} data={props.data.NOT_APPROVED} />
                    </div>
                </div>
            </Grid>}
            {/* not-assigned Table */}
            {props.data.APPROVED && <Grid container item xs={12} alignItems="flex-end" style={{ marginTop: "50px" }}>
                <div className={classes.item}>
                    <div className={classes.paper}>
                        <SimpleTable head={approvedHead} action={notAssignedAction} data={props.data.APPROVED} />
                    </div>
                </div>
            </Grid>}
        </>
    )
}

export default Manual3PL;
